<template>
    <div class="hello">

        <main id="main" @click="deleteSty()">

            <div class="banner">
                <nav-igation class="nav homeNav" ref="navGradient"></nav-igation>
                <img :src="bannerUrl" @click="bannerClick(bannerLink)" v-show='bannerUrl' id="BannerShow" alt="">
                <div class="viewType">
                    <img src="@/image/logo_1_new.png" alt="">
                    <div @click="videoView = true">
                        <img src="@/image/logo_2.png" alt="">
                    </div>
                </div>
                <!-- <img src="@/image/video.png" @click="videoView = true" class="video" alt=""> -->
                <div class="test">
                    <h3>真商实资 促产融城</h3>
                    <p>重资产市场化招商引资服务商</p>
                    <div class="but">
                        <div @click="abutmentClick('park')">园区招商对接 <img src="@/image/banban.png" alt=""></div>
                        <div @click="abutmentClick('ent')">企业选址对接 <img src="@/image/banban.png" alt=""></div>
                    </div>
                    <a href="#mapView"><img src="@/image/BanNext.png" class="BanNext" @click="nextMap()" alt=""></a>
                </div>
                <div class="videoView" v-if="videoView">
                    <video :src="HomeVideo" autoplay></video>
                    <img src="@/image/videoGuan.png" @click="videoView = false" alt="">
                </div>
                <div class="subscript">
                    <div class="view">
                        <p :class="{ 'subP': sub == index }" v-for="(item, index) in bannerData" :key="index + 'banner'"
                            @click="bannerLi(item, index)">{{ (index + 1) <= 9 ? ('0' + (index + 1)) : index + 1 }}</p>
                                <div :style="{ 'left': sub * 46 + 23 + 'px' }"></div>
                    </div>
                </div>
            </div>
            <div id="mapView">
                <nav-igation class="nav" id="navView"></nav-igation>
                <div style="min-height: 370px;width: 100%;">
                    <div class="title testAnima">
                        <h2>中云工业园</h2>
                        <h2 style="font-size: 18px;"> ZHONGYUN INDUSTRIAL PARK </h2>
                        <!-- <p>中云工业园，由北控系推动，香港中云有限公司、北京小招云有限公司联合进行项目实施。专注于工业产业集群重资产投资建设，助力地区实体经济高质量发展。
                            以“真商实资、促产融城”作为园区招商引资标准，搭建起智慧化、数据化、全程化的园区建设与管理架构通过“强链补链、建链创链”的专业性规划，
                            促进地方产业链提质升级，为地方经济增长注入新鲜活力。
                        </p> -->
                        <p>北京小招云有限公司，是一家主要从事空地规划招商、土地调规盘活、闲置资产处置、园区运营管理的重资产市场化招商引资服务商。北京小招云重点打造的“中云工业园”品牌采用“统规自建+双保姆+陪伴成长”服务模式，专注于为地区规划高质量工业园区，并进行优质重资产招商引资建设，促进地方产业链提质升级，助力实体经济高质量发展。</p>
                        <div class="butSty" @click="$router.push({ path: '/park' })">查看详情
                            <img src="@/image/but1.png" alt="">
                        </div>
                    </div>
                </div>

                <div class="map">
                    <div id="echMap"></div>
                    <img :src="require(imgRou == 'm-' ? '@/image/m-dq.png' : '@/image/dq.png')" class="theEarth" alt="">
                </div>
                <div class="mapLoad">
                    <img src="@/image/mapLoad.gif" alt="">
                </div>
            </div>
            <div class="parkView">
                <div class="item" @click="parkByRef($event)">
                    <img :src="require('@/image/' + imgRou + 'park1.jpg')" class="park" alt="">
                    <div class="test">
                        
                        <h3>01</h3>
                        <p>中云工业园</p>
                    </div>
                    <div class="barkInfo">
                        <div class="title">中云工业园</div>
                        <p>从用地规划、产业分析、数字招商平台搭建，到精准招商、入园企业服务提供全流程落地方案，以“专业、高效、务实”作为项目执行标准，打造优势园区生态。助力企业以最优成本、最高效率落地投产；助力政府获得精准匹配、企业优质的招商成果
                        </p>
                        
                        <div class="img" @click="$router.push({ path: '/park' })">
                            <img src="@/image/parkBut1.png" alt="">
                            <img src="@/image/parkBut2.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="item">
                    <img :src="require('@/image/' + imgRou + 'park2.jpg')" class="park" alt="">
                    <div class="test">
                        <h3>02</h3>
                        <p>招商引资管理平台</p>
                    </div>
                    <div class="barkInfo">
                        <div class="title">招商引资管理平台</div>
                        <p>解决地方招商引资需求，依托海量数据积累，生成产业全景图，挖掘促进产业发展的价值资源，精准锁定招商线索和关键触达路径，高效对接优质企业，动态智配扶持政策，开展靶向招商。项目招后落地服务及检测，形成项目全程跟踪、随时调度、联动推进的良好机制和过程可追溯、实时可跟踪的全流程管理模式，实现数字化招商管理，全面提升招商引资及企业落地效率。
                        </p>
                        <div class="img">
                            <img src="@/image/parkBut1.png" alt="">
                            <img src="@/image/parkBut2.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="item">
                    <img :src="require('@/image/' + imgRou + 'park3.jpg')" class="park" alt="">
                    <div class="test">
                        <h3>03</h3>
                        <p>安全生产管理平台</p>
                    </div>
                    <div class="barkInfo">
                        <div class="title">安全生产管理平台</div>
                        <p>依托各级单位对危化安全生产的管理要求，搭建企业安全生产云平台，实现操作控制智能化、风险预警精准化、危险作业无人化、运维辅助远程化，提升安全生产管理的可预测、可管控水平。强化企业快速感知、实时监测、超前预警、动态优化、智能决策、联动处置、系统评估、全局协同能力，实现提质增效、消患固本，打造企业工业互联网新基础设施，为企业新发展注入新动能。
                        </p>
                        <div class="img">
                            <img src="@/image/parkBut1.png" alt="">
                            <img src="@/image/parkBut2.png" alt="">
                        </div>

                    </div>
                </div>
                <div class="item">
                    <img :src="require('@/image/' + imgRou + 'park4.jpg')" class="park" alt="">
                    <div class="test">
                        <h3>04</h3>
                        <p>企业选址服务</p>
                    </div>
                    <div class="barkInfo">
                        <div class="title">企业选址服务</div>
                        <p>依托企业选址需求，绘制企业详细画像，匹配性分析企业增产选址方向，提供定制化选址建议。全流程一对一服务，根据企业选址方向，生成企业项目简介，匹配查询园区空地情况，协助企业进行选址考察对接，为企业制定最优惠用地方案。企业拿地后提供管家式手续代办，助力企业高效投产。
                        </p>
                        <div class="img">
                            <img src="@/image/parkBut1.png" alt="">
                            <img src="@/image/parkBut2.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="item">
                    <img :src="require('@/image/' + imgRou + 'park5.jpg')" class="park" alt="">
                    <div class="test">
                        <h3>05</h3>
                        <p>智能仓储</p>
                    </div>
                    <div class="barkInfo">
                        <div class="title">智能仓储</div>
                        <p>依托市区内闲置中小型厂房，解决市区内个人、微小型企业及中小型物流企业货物存放问题，实现货品物资集中、分类、规范的统一管理。货物信息共享，配套货物定位、查找、录入的智能系统，便于客户自行取货。为个人、企业客户提供低价租赁服务场地的同时专注于物流货品的消防、防爆、消杀、应急安全管理，避免货品随意堆放所带来的安全隐患。
                        </p>
                        <div class="img">
                            <img src="@/image/parkBut1.png" alt="">
                            <img src="@/image/parkBut2.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div id="direction">
                <div class="title">
                    <div>五大产业方向</div>
                    <p> Five industrial directions </p>
                </div>
                <div class="content">
                    <div class="leftItem">
                        <div class="direSty" style="margin-left: 0;">
                            <img :src="require('@/image/' + imgRou + 'dire1.jpg')" alt="">
                            <div class="test">
                                <div>高端装备制造</div>
                                <p>机器人制造、航空设备制造、液压元件制造、智能锻铸造、轨道交通装备制造、海洋工程装备制造</p>
                            </div>
                        </div>
                        <div class="direSty direAnima1">
                            <img :src="require('@/image/' + imgRou + 'dire2.jpg')" alt="">
                            <div class="test">
                                <div>新能源汽车产业</div>
                                <p>汽车装置、配件制造</p>
                            </div>
                        </div>
                    </div>
                    <div class="square" v-if="device == 'ipad' || device == 'm'">
                        <div class="direSty">
                            <img :src="require('@/image/' + imgRou + 'dire5.jpg')" alt="">
                            <div class="test" style="top: 60%;">
                                <div>食品加工</div>
                                <p>预制菜加工、功能性食品加工、休闲食品加工、食品添加剂加工</p>
                            </div>
                        </div>
                        <div class="direSty">
                            <img :src="require('@/image/' + imgRou + 'dire3.jpg')" alt="">
                            <div class="test" style="top: 60%;">
                                <div>新材料产业</div>
                                <p>新型建材、高性能纤维、特种玻璃、特种陶瓷、生物基、淀粉基材料</p>
                            </div>
                        </div>
                        <div class="direSty">
                            <img :src="require('@/image/' + imgRou + 'dire4.jpg')" alt="">
                            <div class="test" style="top: 60%;">
                                <div>生物产业</div>
                                <p>生物医药、中成药加工、医疗器械、生物农业-兽用制品</p>
                            </div>
                        </div>
                    </div>
                    <div class="square" v-else>
                        <div class="flex">
                            <div class="direSty direAnima2">
                                <img src="@/image/dire3.jpg" alt="">
                                <div class="test" style="top: 60%;">
                                    <div>新材料产业</div>
                                    <p>新型建材、高性能纤维、特种玻璃、特种陶瓷、生物基、淀粉基材料</p>
                                </div>
                            </div>
                            <div class="direSty direAnima3">
                                <img src="@/image/dire4.jpg" alt="">
                                <div class="test" style="top: 60%;">
                                    <div>生物产业</div>
                                    <p>生物医药、中成药加工、医疗器械、生物农业-兽用制品</p>
                                </div>
                            </div>
                        </div>
                        <div class="direSty direAnima4" style="margin-top: 10px;">
                            <img src="@/image/dire5.jpg" alt="">
                            <div class="test">
                                <div>食品加工</div>
                                <p>预制菜加工、功能性食品加工、休闲食品加工、食品添加剂加工</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="greenFactory">
                <div class="greenImg">
                    <div>绿色工业</div>
                    <p> Green Industry </p>
                    <div class="more" @click="$router.push({ path: '/greenFactory' })">
                        <p>了 解 更 多 ></p>
                    </div>
                </div>
            </div>
            <div id="news">
                <div class="title">
                    <div>新闻中心</div>
                    <p> News Centre </p>
                </div>
                <div class="content">
                    <div class="itemNews newsAnima1" v-if="newsData[0]">
                        <div class="img">
                            <img :src="newsData[0].cover" alt="">
                        </div>

                        <div class="test">
                            <h3>{{ newsData[0].name }}</h3>
                            <p>{{ newsData[0].introduction }}</p>
                        </div>
                        <div class="but" @click="$router.push({ path: '/newsInfo', query: { id: newsData[0].id } })">
                            <img src="@/image/an.png" alt="">
                        </div>
                    </div>
                    <div class="itemNews newsAnima2" v-if="newsData[1]">
                        <div class="img">
                            <img :src="newsData[1].cover" alt="">
                        </div>
                        <div class="test">
                            <h3>{{ newsData[1].name }}</h3>
                            <p>{{ newsData[1].introduction }}</p>
                        </div>
                        <div class="but" @click="$router.push({ path: '/newsInfo', query: { id: newsData[1].id } })">
                            <img src="@/image/an.png" alt="">
                        </div>
                    </div>
                    <div class="tableSty newsAnima3">
                        <div class="liSty" v-for="(item, index) in newsData" :key="index + 'news'"
                            @click="$router.push({ path: '/newsInfo', query: { id: item.id } })">
                            <div class="date">
                                <h3>{{ item.createTime.split('-')[2] }}</h3>
                                <p>{{ item.createTime.split('-')[0] }}/{{ item.createTime.split('-')[1] }}</p>
                            </div>
                            <div class="test">
                                {{ item.name }}
                            </div>
                            <img src="@/image/listIcon.png" alt="">
                        </div>
                        <div class="more" @click="$router.push({ path: '/news' })">
                            <p>更多新闻</p>
                            <img src="@/image/moreIcon.png" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="ContactUs">
                <!-- 联系我们 -->
                <div class="left" id="baiduMap">
                </div>
                <div class="right">
                    <div class="info">
                        <div class="title">
                            <span>联系我们</span>
                            <span>CONTACT US</span>
                        </div>
                        <p>
                            <img src="@/image/Contact1.png" alt="">
                            <!-- 大兴区-金星西路5号绿地财富中心B座1103号 -->
                            搜宝商务中心3号楼20层
                        </p>
                        <p>
                            <img src="@/image/Contact2.png" alt="">
                            18611285531
                        </p>
                        <p>
                            <img src="@/image/Contact3.png" alt="">
                            zhongyu90349@163.com
                        </p>
                    </div>
                    <div class="codeView">
                        <div class="codeItem">
                            <img src="@/image/ContacCode1.jpg" alt="">
                            <p>公务对接</p>
                        </div>
                        <div class="codeItem">
                            <img src="@/image/ContacCode2.jpg" alt="">
                            <p>企业对接</p>
                        </div>
                        <div class="codeItem">
                            <img src="@/image/ContacCode2.jpg" alt="">
                            <p>政府对接</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="FooterBody" style="height: 500px;">
                <Footer></Footer>
            </div>
        </main>

        <el-dialog title="" class="dialogSty" :visible.sync="parkDialog" :width="device == 'm' ? '85%' : '500px'">
            <div class="title">{{ dialog == 'park' ? '园区落户申请' : '企业选址对接' }}</div>
            <div class="itemSty">
                <p>{{ dialog == 'park' ? '单位名称' : '企业名称' }}</p>
                <el-input v-model="formData.name" placeholder=""></el-input>
            </div>
            <div class="flexView">
                <div class="itemSty">
                    <p>联系人</p>
                    <el-input v-model="formData.person" placeholder=""></el-input>
                </div>
                <div class="itemSty">
                    <p>联系人职位</p>
                    <el-input v-model="formData.position" placeholder=""></el-input>
                </div>
            </div>
            <div class="flexView">
                <div class="itemSty">
                    <p>联系电话</p>
                    <el-input v-model="formData.phone" placeholder=""></el-input>
                </div>
                <div class="itemSty" v-if="dialog == 'park'">
                    <p>土地面积</p>
                    <el-input v-model="formData.area" placeholder=""></el-input>
                </div>
                <div class="itemSty" v-else>
                    <p>所属行业</p>
                    <div class="selectView">
                        <el-select v-model="formData.industryFirst" value-key="id" @change="industryClick($event)"
                            placeholder="">
                            <el-option v-for="item in industry1" :key="item.id" :label="item.name"
                                :value="{ id: item.id, name: item.name }">
                            </el-option>
                        </el-select>
                        <el-select v-model="formData.industrySecond" placeholder="">
                            <el-option v-for="item in industry2" :key="item.id" :label="item.name" :value="item.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="itemSty">
                <div class="itemSty">
                    <p>地理位置</p>
                    <div class="selectView">
                        <el-select v-model="formData.province" value-key="id" @change="posiChange(1, $event)"
                            placeholder="省">
                            <el-option v-for="item in posi1" :key="item.id" :label="item.name"
                                :value="{ id: item.id, name: item.name }">
                            </el-option>
                        </el-select>
                        <el-select v-model="formData.city" value-key="id" @change="posiChange(2, $event)" placeholder="市">
                            <el-option v-for="item in posi2" :key="item.id" :label="item.name"
                                :value="{ id: item.id, name: item.name }">
                            </el-option>
                        </el-select>
                        <el-select v-model="formData.county" placeholder="区">
                            <el-option v-for="item in posi3" :key="item.id" :label="item.name" :value="item.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="but" @click="formSubmit()">提交</div>
        </el-dialog>
    </div>
</template>
<script>
import { newsList, bannerList, GetVideo, getPosi, saveSite, saveSettle, getIndustry, getIndustryPid } from '@/api/home.js'
import echarts from 'echarts'
import axios from 'axios'
import { Message } from 'element-ui'
import SVGA from 'svgaplayerweb';
// import './china.json'
var time = null
var intervalId = null
export default {
    name: 'home',
    data() {
        return {
            parkDialog: false,
            sub: 0,
            HomeVideo: '',
            videoView: false,
            bannerUrl: '',
            bannerLink: '',
            bannerData: [],
            newsData: [],
            navSty: true,
            device: '',
            imgRou: '',//图片引入端 默认pc 
            options: [],
            formData: {
                province: '',
                city: '',
                county: '',
                industryFirst: '',
                industrySecond: ''
            },
            posi1: [],
            posi2: [],
            posi3: [],
            dialog: '',
            industry1: [],
            industry2: []
        }
    },
    mounted() {
        var vw = window.screen.width
        if (vw <= 1224) {
            this.device = 'ipad'
            this.imgRou = 'i-'
        }
        if (vw <= 750) {
            this.device = 'm'
            this.imgRou = 'm-'
        }
        getPosi('?sort=0').then(res => {
            this.posi1 = res.data
        })
        getIndustry().then(res => {
            this.industry1 = res.data
        })
        if (this.device == 'ipad' || this.device == 'm') {
            var then = this
            window.addEventListener("scroll", function (e) {
                var y = window.scrollY
                var $el = then.$refs.navGradient.$el
                if (!$el) return;
                var navLogo = $el.getElementsByClassName('navLogo')[0]
                if (y >= 200) {
                    $el.className = 'nav homeNav white'
                    $el.style = 'transition: .8s ease;background:#fff'
                    navLogo.style.display = 'block'
                } else {
                    $el.className = 'nav homeNav'
                    $el.style = 'transition: .8s ease;background:transparent'
                    navLogo.style.display = 'none'
                }
            })
        }
        let box = document.querySelector("#main");
        var then = this
        box.addEventListener("scroll", function (e) {
            let scrollTop = e.target.scrollTop;//距顶部
            var direction = document.querySelector('#direction')
            var mapView = document.querySelector('#mapView')
            var news = document.querySelector('#news')
            var navView = document.querySelector('#navView')

            if (scrollTop < 200) {
                clearTimeout(time)
                navView.style = 'display:none'
                // then.navSty = true
            }
            if (direction.getBoundingClientRect().top < 100) {
                direction.className = 'animaSty'
            }
            if (mapView.getBoundingClientRect().top < 100) {
                mapView.className = 'animaSty'
                navView.style = 'display:'
                if (then.navSty) {
                    navView.className = 'nav white'
                    setTimeout(() => {
                        navView.className = 'nav white noWhite'
                        then.navSty = false
                    }, 4000);
                }
            }
            if (news.getBoundingClientRect().top < 100) {
                news.className = 'animaSty'
            }
        })
        this.init()
        this.echinit()
    },
    methods: {


        bannerClick(url) {
            console.log(url)
            if (!url) return;
            window.open(url)
        },
        abutmentClick(type) {
            this.formData = {
                province: '',
                city: '',
                county: '',
                industryFirst: '',
                industrySecond: ''
            },
                this.dialog = type
            this.parkDialog = true
        },
        industryClick(item) {
            this.formData.industryFirst = item.name
            this.formData.industrySecond = ""
            this.industry2 = []
            getIndustryPid(item.id).then(res => {
                this.industry2 = res.data
            })
        },
        posiChange(type, item) {
            if (type == 1) {
                this.formData.province = item.name
                this.posi2 = []
                this.posi3 = []
                this.formData.city = ""
                this.formData.county = ""
                getPosi('?sort=1&pid=' + item.id).then(res => {
                    this.posi2 = res.data
                })
            } else if (type == 2) {
                this.formData.city = item.name
                this.posi3 = []
                this.formData.county = ""
                getPosi('?sort=1&pid=' + item.id).then(res => {
                    this.posi3 = res.data
                })
            }
        },
        formSubmit() {
            var { name, person, position, phone, area, county, industrySecond } = this.formData
            if (!name) {
                return Message.error((this.dialog == 'park' ? '单位名称' : '企业名称') + '不能为空');
            }
            if (!person) {
                return Message.error('联系人不能为空');
            }
            if (!position) {
                return Message.error('联系人职位不能为空');
            }
            if (!phone) {
                return Message.error('联系电话不能为空');
            }
            if (!county) {
                return Message.error('请选择地理位置');
            }
            if (this.dialog == 'park') {
                if (!area) {
                    return Message.error('土地面积不能为空');
                }
            } else {
                if (!industrySecond) {
                    return Message.error('请选择所属行业');
                }
            }
            if (this.dialog == 'park') {
                saveSettle(this.formData).then(res => {
                    Message.success('操作成功');
                    this.parkDialog = false
                })
            } else {
                saveSite(this.formData).then(res => {
                    Message.success('操作成功');
                    this.parkDialog = false
                })
            }
        },
        deleteSty() {
            // var view = document.getElementsByClassName('barkInfo')
            // view.forEach(item=>{
            //     item.style = ''
            // })
        },
        parkByRef(e) {
            // var view = e.target
            // console.log(view)
            // var info = view.getElementsByClassName('barkInfo')[0]
            // info.style.top = 0

        },
        nextMap() {

        },
        init() {
            GetVideo().then(res => {
                this.HomeVideo = res.data.vedio
            })
            newsList('pageNum=1&pageSize=5').then(res => {
                res.data.forEach(item => {
                    item.createTime = item.createTime.split(' ')[0]
                });
                this.newsData = res.data
            })
            bannerList(this.device).then(res => {
                this.bannerData = res.data
                this.bannerLi(this.bannerData[0], 0)
                this.setTimeFun()
            })
            this.$nextTick(() => {
                this.InitMap()
            })

        },
        InitMap() {
            var map = new BMapGL.Map('baiduMap');
            // map.centerAndZoom(new BMapGL.Point(116.339077, 39.770451), 15);
            map.centerAndZoom(new BMapGL.Point(116.375117, 39.861168), 15);
            map.enableScrollWheelZoom(true);
            var myIcon = new BMapGL.Icon(require('./mapIcon.png'), new BMapGL.Size(32, 32))         // 根据条件判断icon的图标
            // var marker = new BMapGL.Marker(new BMapGL.Point(116.339077, 39.770451), { icon: myIcon });          // 将图标和坐标进行关联
            var marker = new BMapGL.Marker(new BMapGL.Point(116.375117, 39.861168), { icon: myIcon });  
            map.addOverlay(marker);

            var opts = {
                // position: new BMapGL.Point(116.339077, 39.770451), // 指定文本标注所在的地理位置
                position: new BMapGL.Point(116.375117, 39.861168), // 指定文本标注所在的地理位置
                offset: new BMapGL.Size(-50, -100) // 设置文本偏移量
            };
            // var label = new BMapGL.Label('大兴区-金星西路5号绿地财 <br> 富中心B座1103号', opts);             // 创建文本标注对象
            var label = new BMapGL.Label('搜宝商务中心3号楼20层', opts);             // 创建文本标注对象

            var labelStyle = {
                color: 'blue',
                borderRadius: '5px',
                borderColor: '#ccc',
                boxShadow: '0px 5px 8px 0px rgba(0,0,0,0.14)',
                color: '#303133',
                padding: '12px 15px',
                fontSize: '12px',
                height: '40px',

            }
            label.setStyle(labelStyle);                                 // 自定义文本标注样式
            map.addOverlay(label);

        },
        setTimeFun() {
            clearInterval(intervalId);	//清除定时器
            var then = this
            intervalId = setTimeout(function () {

                var inde = then.sub
                if (inde >= then.bannerData.length - 1) {
                    inde = 0
                } else {
                    inde = inde + 1
                }
                then.bannerLi(then.bannerData[inde], inde)
            }, 6000);

        },
        bannerLi(item, index) {
            var view = document.getElementById('BannerShow')
            view.className = ''
            this.bannerLink = item.reurl
            this.bannerUrl = item.url
            this.sub = index
            setTimeout(() => {
                view.className = 'BannerShow'
            }, 10);
            // this.setTimeFun()
        },
        echinit() {
            var device = this.device
            axios.get('../../static/china.json').then(res => {
                echarts.registerMap('china', res.data)
                this.$nextTick(() => {
                    let myChart = echarts.init(document.getElementById('echMap'))
                    var vh = document.body.clientHeight
                    console.log(vh)
                    var spacing = {}
                    if (device == 'ipad') {
                        spacing = {
                            top: '-7%',
                            left: '-1%',
                            right: '4%',
                            bottom: '-30%',
                        }
                    } else if (device == 'm') {
                        spacing = {
                            top: '1%',
                            left: '0%',
                            right: '0%',
                            bottom: '-5%',
                        }
                    } else if (vh <= 700) {
                        spacing = {
                            top: '-7%',
                            left: '10%',
                            right: '4%',
                            bottom: '-7%',
                        }
                    } else {
                        spacing = {
                            top: '1%',
                            left: '-1%',
                            right: '4%',
                            bottom: '-20%',
                        }
                    }


                    var option = {
                        tooltip: {
                            trigger: 'item',
                            triggerOn: 'click',// 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
                            backgroundColor: 'transparent',
                            borderColor: 'transparent',
                            borderWidth: 1,
                            pointerEvents: 'all',
                            textStyle: {
                                width: 160,
                                height: 250,
                                lineHeight: 24,
                                color: '#666666',
                                fontSize: '14',
                                fontFamily: 'SourceHanSansCN-Normal',

                            },
                            position: function (point, params, dom, rect, size) {
                                // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                                // 提示框位置
                                var x = 0; // x坐标位置
                                var y = 0; // y坐标位置

                                // 当前鼠标位置
                                var pointX = point[0];
                                var pointY = point[1];

                                // 外层div大小
                                // var viewWidth = size.viewSize[0];
                                // var viewHeight = size.viewSize[1];

                                // 提示框大小
                                var boxWidth = size.contentSize[0];
                                var boxHeight = size.contentSize[1];

                                // boxWidth > pointX 说明鼠标左边放不下提示框
                                if (boxWidth > pointX) {
                                    x = 5;
                                } else { // 左边放的下
                                    x = pointX - boxWidth;
                                }

                                // boxHeight > pointY 说明鼠标上边放不下提示框
                                if (boxHeight > pointY) {
                                    y = 5;
                                } else { // 上边放得下
                                    y = pointY - boxHeight;
                                }

                                return [x, y];
                            },
                            formatter: params => {
                                // 获取xAxis data中的数据
                                let dataStr = ``
                                if (!params.data) {
                                    return;
                                }
                                params.data.child.forEach(item => {
                                    dataStr += `<p><i></i>${item}</p>`
                                })
                                return `<div class="mapToolt"><div>${params.name}</div>${dataStr}</div>`
                            }
                        },
                        series: [
                            {
                                ...spacing,
                                containLabel: true,
                                name: '中国',
                                type: 'map',
                                zoom: device == 'ipad' ? 0.6 : device == 'm' ? 0.7 : 0.75,
                                aspectScale: 0.72,
                                mapType: 'china',
                                selectedMode: 'multiple',
                                label: {
                                    normal: {
                                        show: false
                                    },
                                    emphasis: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        borderColor: '#C1D8E7',
                                        areaColor: '#F8FBFD',
                                        borderWidth: 0.5,
                                        show: true,
                                    },
                                    emphasis: {
                                        areaColor: '#EDF2F6',
                                        color: '#F8FBFD',
                                        borderWidth: 2,
                                        show: true,
                                    }
                                },
                                data: [
                                ],
                                markPoint: {
                                    symbol: 'image://' + require('./mapDian.png'),
                                    symbolSize: 30,
                                    // symbolOffset: [0, '-50%'],  // 调整标注图片的位移方向 大小
                                    label: {
                                        normal: {
                                            show: true,
                                            rotate: 5,
                                            color: 'rgba(42, 42, 42, 1)',  // 文字颜色
                                            padding: [0, 0, 0, 70], // 可用padding调整图片内文字距离
                                            formatter: function (d) { return d.name }
                                        }
                                    },

                                    data: [
                                        {
                                            name: '新疆', coord: [87.600353, 43.821911], child: [
                                                '河北援疆科技产业示范十八园',
                                                '河北援疆科技产业示范二十二园',
                                            ]
                                        },
                                        {
                                            name: '陕西', coord: [108.949253, 34.308635], child: [
                                                '中云（南郑）装备制造产业园',
                                            ]
                                        },
                                        {
                                            name: '辽宁', coord: [123.439969, 41.79178], child: [
                                                '中云（细河）智能质造工业园',
                                                '中云（凌源）装备制造工业园',
                                                '中云（铁岭）标准厂房'
                                            ]
                                        },
                                        {
                                            name: '河北', coord: [116.512502, 39.840164], child: [
                                                '中云（鸡泽）装备制造工业园',
                                                '中云（大名）装备制造工业园',
                                                '中云（魏县）装备制造工业园',
                                                '中云（固安）工业园',
                                                '中云工业园京津冀示范一园',
                                                '中云工业园京津冀示范二园',
                                                '中云工业园京津冀示范三园',
                                                '中云工业园京津冀示范四园',
                                                '中云工业园京津冀示范五园',
                                                '中云工业园京津冀示范六园',
                                                '中云工业园京津冀示范七园',
                                                '中云工业园京津冀示范八园',
                                                '中云工业园京津冀示范九园',
                                                '中云工业园京津冀示范十园',
                                                '中云工业园京津冀示范十一园',
                                                '中云工业园京津冀示范十二园',
                                                '中云工业园京津冀示范十三园',
                                                '中云工业园京津冀示范十四园',
                                                '中云工业园京津冀示范十五园',
                                                '中云工业园京津冀示范十七园',
                                            ]
                                        },
                                        {
                                            name: '山东', coord: [117.00895, 36.685647], child: [
                                                '中云工业园京津冀示范十六园',
                                            ]
                                        },
                                        {
                                            name: '河南', coord: [112.42, 34.16], child: [
                                                '中云（潢川）智能制造工业园',
                                                '中云（新郑）应急产业工业园',
                                                '中云（荣阳）装备制造工业园',
                                            ]
                                        },
                                        {
                                            name: '四川', coord: [102.54, 30.05], child: [
                                                '中云（恩阳）智能制造工业园',
                                            ]
                                        },
                                        // {
                                        //     name: '江苏', coord: [118.807605, 32.07621], child: [
                                        //         '苏南智城科技产业园',
                                        //         '嘉地苏州国际产业园'
                                        //     ]
                                        // },
                                        // {
                                        //     name: '浙江', coord: [120.155889, 30.304701], child: [
                                        //         '宝地嘉兴国际产业园',
                                        //     ]
                                        // },
                                    ]
                                }
                            }
                        ]
                    };
                    myChart.setOption(option)
                    window.addEventListener("resize", function () {
                        myChart.resize();
                    });
                })
            })

        },
    }
}
</script>
<style>
.el-scrollbar>.el-scrollbar__bar {

    opacity: 1 !important;
}

.el-scrollbar__view .el-select-dropdown__item {
    padding-left: 15px;
}

.homeNav .logo {
    opacity: 0;
}

#echMap>div {
    pointer-events: all !important;
}

.mapToolt {
    width: 300px;
    max-height: 350px;
    overflow: auto;
    background: #fff;
    transform: rotate3d(0.5, 0, 0.8, -7deg);
    padding-bottom: 10px;
}

.mapToolt div {
    line-height: 50px;
    background: #F7F7FA;
    padding: 0 25px;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
}

.mapToolt p {
    line-height: 40px;
    background: #fff;
    padding: 0 15px;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.mapToolt p i {
    display: block;
    width: 8px;
    height: 8px;
    background: #2EA7E0;
    border-radius: 50%;
    margin-right: 10px;
}
</style>
<style lang="scss" scoped>
@import url(./animation.scss);



.dialogSty {
    color: #303133;

    .but {
        width: 110px;
        height: 40px;
        background: linear-gradient(270deg, #00AAFF 0%, #4D5EFA 49%, #A259FB 100%);
        font-size: 11px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
        line-height: 40px;
        margin: auto;
        margin-top: 30px;
    }

    .selectView {
        display: flex;
    }

    .title {
        font-size: 19px;
        font-weight: 600;
        text-align: center;
    }

    .flexView {
        display: flex;
        justify-content: space-between;

        .itemSty {
            width: 46%;
        }
    }

    .itemSty {
        margin-top: 17px;

        p {
            font-size: 13px;
        }
    }

    >>>.el-input__inner {
        border: none;
        background: #F5F5F5;
        margin-top: 6px;
    }

    >>>.el-dialog__headerbtn {
        background: #C4C7CC;
        border-radius: 50%;

        i {
            padding: 4px;
            color: #212122;
            font-weight: 800;
            font-size: 14px;
        }
    }
}

.homeNav {
    z-index: 10;
    opacity: .8;
}

#baiduMap {
    z-index: 0;
}

.viewType {
    width: 124px;
    height: 190px;
    background: #2EA7E0;
    position: absolute;
    left: 100px;
    top: 20px;
    z-index: 5;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 10px 0;

    >img {
        width: 72px;
    }

    div {
        width: 65px;
        height: 45px;
        border-radius: 30px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
        }
    }
}

body,
html,
#main {
    scroll-behavior: smooth;
}

.noWhite {
    animation-duration: 0s;
    animation: none !important;
}

#mapView .white {
    position: fixed !important;
    top: 0;
    background: #FFFFFF;
    animation: whiteShow 1.3s ease 0s forwards;
    animation-delay: 1s;
}

@keyframes whiteShow {
    0% {
        top: -80px;
    }

    100% {
        top: 0;
    }
}

.subP {
    font-size: 28px !important;
    color: #2EA7E0 !important;
}

.ContactUs {
    display: flex;

    .left {
        img {
            width: 100%;
        }
    }

    .left,
    .right {
        width: 50%;
        height: 100%;
    }

    .right {
        .codeView {
            display: flex;
            margin: 0 150px;
            justify-content: space-between;
        }

        .codeItem {
            width: 90px;


            img {
                width: 90px;
            }

            >p {
                font-size: 11px;
                color: #303133;
                text-align: center;
                margin-top: 0;
                justify-content: center;
            }
        }

        .info {
            margin: 150px;
        }

        .title {
            font-size: 30px;
            font-weight: 600;
            color: #303133;
            overflow: hidden;
        }

        .title span:nth-child(2) {
            font-size: 20px;
            margin-top: 10px;
            display: block;
            margin-bottom: 35px;
        }

        p {
            display: flex;
            font-size: 14px;
            color: #303133;
            margin-top: 18px;

            img {
                width: 24px;
                height: 24px;
                margin-right: 30px;

            }
        }
    }
}

.mapLoad {
    display: flex;
    justify-content: center;
    // align-items: center;
    position: absolute;
    left: 0;
    z-index: 5;
    background: #B7D6E9;
    width: 100%;
    height: 100%;

    >img {
        width: 600px;
        height: 600px;
        margin-top: calc(50vh - 300px);
    }
}

@media screen and (max-width: 1225px) {
    #media_weight {
        #greenFactory{
            height: 120vh;
            background-image: url('../../image/greenImg2.png');
            background-size: 100% 100%;
            flex-direction: column;
            position: relative;
        }
        .greenImg{
            div{
                font-size: 20px;
                margin-top: 5%;
            }
            p{
                margin-top: auto !important;
                font-size: 20px !important;
            }
            .more{
                width: 140px !important;
                height: 35px !important;
                bottom: 38% !important;
                border: 1px solid #fff !important;
                left: 32% !important;
                p{
                    font-size: 16px !important;
                    line-height: 30px;
                }
            }
        }
    }

}

#greenFactory {
    background-image: url('../../image/greenImg.png');
    background-size: 100% 100%;
    flex-direction: column;
    position: relative;
    .greenImg {
        font-size: 25px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        width: 100%;
        margin-top: 7%;

        p {
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 10px;
        }
        .more{
            position: absolute;
            bottom: 40%;
            border: 2px solid #fff;
            left: 45.5%;
            width: 200px;
            height: 50px;
            border-radius: 50px;
            font-weight: normal;
            cursor: pointer;
            line-height: 30px;
        }
    }
}
#news {
    background-image: url('../../image/newsBack.jpg');
    background-size: 100% 100%;
    flex-direction: column;

    .tableSty {
        width: 313px;
        // height: 100%;
        background: #FFFFFF;
        padding-top: 20px;
        max-height: 100%;
        overflow: auto;

        .more {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: RGBA(78, 181, 229, 1);
            line-height: 18px;
            justify-content: space-between;
            border-top: 1px solid #E8EAED;
            height: 70px;
            // margin-bottom: 20px;
            cursor: pointer;
            padding: 0 25px;

            img {
                width: 24px
            }
        }

        .liSty:hover {
            background: #EBEEF0;
        }

        .liSty {
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 10px 25px;

            .test {
                font-size: 13px;
                min-height: 100%;
                color: rgba(0, 0, 0, 0.8);
                line-height: 20px;
                margin-left: 20px;
                flex: 1;
            }

            img {
                width: 24px;
                height: 24px;
            }


            .date {
                width: 45px;

                h3 {
                    font-size: 28px;
                    font-weight: 800;
                    color: #000;
                    line-height: 36px;
                    text-align: center;
                }

                p {
                    font-size: 9px;
                    font-weight: 500;
                    color: #94979D;
                    line-height: 16px;
                }

            }

        }
    }

    .content {
        // width: 80%;
        height: 490px;
        margin: auto;
        display: flex;

        .itemNews .img:hover img {
            width: calc(100% + 16px);
            height: calc(100% + 5px);
            margin-left: -8px;
            margin-top: -5px;
        }

        .itemNews {
            width: 445px;
            height: 490px;
            background: #fff;
            margin-right: 30px;

            >.img {
                width: 100%;
                height: 296px;
                overflow: hidden;

                img {
                    width: 100%;
                    transition: 0.3s ease;
                }
            }

            .test {
                margin-left: 30px;
                height: 112px;
                overflow: hidden;

                h3 {
                    font-size: 13px;
                    font-weight: 600;
                    color: #303133;
                    line-height: 28px;
                    margin-top: 20px;
                }

                p {
                    font-size: 11px;
                    color: #303133;
                    margin-top: 5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    padding-right: 15px;
                    line-height: 19px;
                }
            }
        }

        .but {
            width: 70px;
            height: 30px;
            background: linear-gradient(270deg, #00AAFF 0%, #4D5EFA 49%, #A259FB 100%);
            border-radius: 15px;
            margin-left: 30px;
            margin-top: 12px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .title {
        font-size: 25px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        width: 100%;
        margin-top: 7%;

        p {
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 10px;
        }
    }
}

#direction {
    background-image: url('../../image/directionBack.jpg');
    background-size: 100% 100%;
    flex-direction: column;

    .content {
        // width: 60%;
        height: 477px;
        margin: auto;
        display: flex;

        .leftItem {
            display: flex;
        }

        .direSty:hover img {
            width: calc(100% + 16px);
            height: calc(100% + 16px);
            margin-left: -8px;
            margin-top: -8px;
        }

        .direSty {
            width: 291px;
            height: 100%;
            overflow: hidden;
            position: relative;
            margin-left: 10px;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                transition: 0.3s ease;
            }

            .test {
                width: calc(100% - 60px);
                height: 120px;
                font-size: 18px;
                font-weight: 600;
                color: #fff;
                position: absolute;
                left: 0px;
                // top: 78%;

                bottom: 0;
                z-index: 1;
                padding: 0 30px;
                background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%);

                p {
                    font-size: 14px;
                    margin-top: 10px;
                    padding-bottom: 20px;
                    color: #E8EAED;
                }
            }
        }

        .square {
            width: 592px;
            height: 100%;

            .flex {
                height: 234px;
                display: flex;
            }

            >.direSty {
                width: calc(100% - 10px);
                height: 234px;

            }
        }
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        color: #303133;
        text-align: center;
        width: 100%;
        margin-top: 7%;

        p {
            font-size: 20px;
            color: #303133;
            margin-top: 10px;
        }
    }
}

.parkView {
    position: relative;
    overflow: hidden;

    .barkInfo {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 100%;
        background-image: url(../../image/parkBg.jpg);
        background-size: 100% 100%;
        color: #fff;
        transition: 0.5s ease;

        .title {
            font-size: 19px;
            font-weight: 600;
            text-align: center;
            margin-top: 160px;
        }

        p {
            font-size: 13px;
            height: 48%;
            overflow: auto;
            margin: 30px 72px;
        }

        .img {
            width: 120px;
            margin: auto;
            cursor: pointer;

            img {
                width: 100%;
                display: block;
            }

            img:nth-child(2) {
                display: none;
            }
        }

        .img:hover img:nth-child(1) {
            display: none;
        }

        .img:hover img:nth-child(2) {
            display: block;
        }

    }

    .item:hover .barkInfo {
        top: 0;
    }

    .item:hover .park {
        width: calc(100% + 16px);
        height: calc(100% + 16px);
        margin-left: -8px;
        margin-top: -8px;
    }

    .item {
        width: 20%;
        height: 100%;
        overflow: hidden;
        position: relative;


        .park {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: -1;
            transition: 0.5s ease;
        }

        .test {
            color: #FFFFFF;
            margin-left: 45px;
            margin-top: 84vh;

            h3 {
                font-size: 27px;
                font-weight: 800;
            }

            p {
                font-size: 14px;
                font-weight: 600;
                margin-top: 11px;
            }
        }
    }

}

.butSty {
    width: 130px;
    height: 40px;
    background: linear-gradient(270deg, #00AAFF 0%, #4D5EFA 49%, #A259FB 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
    border-radius: 2px;

    img {
        width: 16px;
        margin-left: 5px;
    }
}

#mapView {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;

    .map {
        width: 100%;
        height: 60vh;
        flex-shrink: 0;
        //overflow: hidden;
        position: relative;

        .theEarth {
            width: 100%;
            height: 100%;
            position: absolute;
            // top: -50px;
            bottom: 0;
        }

        #echMap {
            width: 1100px;
            height: 600px;
            margin: auto;
            padding-right: 3%;
            position: relative;
            top: -5%;
            z-index: 3;
            // transform: rotated(6deg);
            transform: rotate3d(0.5, 0, 0.8, 7deg);
        }
    }

    .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 992px;
        width: 80%;
        margin: auto;

        h2 {
            font-size: 28px;
            font-weight: 600;
            color: #303133;
            margin-top: 10px;
        }

        p {
            font-size: 13px;
            color: #606266;
            line-height: 28px;
            margin: 18px 0;
        }
    }
}

.banner {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    .videoView {
        width: 65%;
        // height: 715px;
        height: min-content;
        background: #606266;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 10;

        video {
            width: calc(100% - 20px);
            // height: calc(100% - 20px);
            height: auto;
            padding: 10px;
            padding-bottom: 0;
        }

        img {
            width: 25px;
            position: absolute;
            right: -10px;
            top: -10px;
        }
    }

    .test {
        width: 656px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: -20px;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .BanNext {
            width: 52px;
            position: relative;
            top: 50px;
            animation: BanNext 2s infinite;
            animation-direction: alternate;
            cursor: pointer;
        }

        @keyframes BanNext {
            0% {
                top: 50px;
            }

            100% {
                top: 100px;
            }
        }

        h3 {
            font-size: 72px;
            font-weight: 800;
            color: #fff;
            line-height: 94px;
        }

        p {
            font-size: 30px;
            color: #ffff;
            margin-top: 20px;
        }

        .but {
            display: flex;

            div {
                width: 140px;
                height: 40px;
                background: linear-gradient(270deg, #00AAFF 0%, #4D5EFA 49%, #A259FB 100%);
                font-size: 14px;
                color: #FFFFFF;
                align-items: center;
                display: flex;
                justify-content: center;
                margin: 40px;
                cursor: pointer;

                img {
                    width: 16px;
                    margin-left: 4px;
                }
            }
        }
    }

    .subscript {
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        left: 0;

        .view {
            display: flex;
            position: relative;

            p {
                width: 46px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                color: #FFFFFF;
                margin-bottom: 75px;
                cursor: pointer;
            }

            div {
                width: 1px;
                height: 61px;
                background: #2EA7E0;
                position: absolute;
                bottom: 0;
                transition: 0.5s ease;
            }
        }
    }

    // .video {
    //     width: 130px;
    //     position: absolute;
    //     left: 100px;
    //     top: 140px;
    //     cursor: pointer;
    // }

    #BannerShow {
        width: 100%;
        height: 100%;
        transition: 4s ease;
    }
}

.nav {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
}

* {
    padding: 0;
    margin: 0;
}

#main {
    width: 100vw;
    height: 100vh;
    overflow: auto;
    scroll-snap-type: y mandatory;
}

#main::-webkit-scrollbar {
    width: 0;
}

#main>div {
    width: 100vw;
    height: 100vh;
    color: #000;
    font-size: 30px;
    overflow: hidden;
    display: flex;
    // justify-content: center;
    // align-items: center;
    scroll-snap-align: start;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/home/home.vue